<section id="modal" class="modal modal--{{modalData.type}}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="flex-always flex--space-between">
          <p class="text text-primary modal-title">{{modalData.title}}</p>
          <a href="javascript:void(0);" class="modal-close" (click)="close($event)"><i class="icon">cross</i></a>
        </div>
      </div>
      <div class="modal-body">
        <p class="text text-secondary" [innerHtml]="modalData.content"></p>
        <div class="btn-group flex-always flex--space-between">
          <button class="btn btn-secondary" (click)="close($event)">{{modalData.cancelButtonText}}</button>
          <button class="btn btn-danger" (click)="removeService()">{{modalData.confirmButtonText}}</button>
        </div>
      </div>
    </div>
  </div>
</section>
